import { useQuery } from '@tanstack/react-query';
import { payCodeApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

export function usePayCodes() {
  return useQuery({
    queryKey: queryKeys.payCodes.list(),
    queryFn: ({ signal }) => payCodeApiClient.list({}, toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: {
      suppressErrorToast: true,
      errorContext: 'pay codes',
    },
  });
}
